import { createContext, ReactNode, useContext } from 'react';

export interface BulkSelectionContextValue<T> {
  selectedRows: T[];
  isLoadingAll: boolean;
  clearSelection: () => void;
  selectionCount: number;
}

const BulkSelectionContext = createContext<BulkSelectionContextValue<unknown> | undefined>(undefined);

export const BulkSelectionProvider = <T,>({
  children,
  value,
}: {
  children: ReactNode;
  value: BulkSelectionContextValue<T>;
}) => (
  <BulkSelectionContext.Provider value={value as BulkSelectionContextValue<unknown>}>
    {children}
  </BulkSelectionContext.Provider>
);

export const useBulkSelectionContext = <T,>(): BulkSelectionContextValue<T> | undefined => {
  return useContext(BulkSelectionContext) as BulkSelectionContextValue<T> | undefined;
};
